import { render, staticRenderFns } from "./view.vue?vue&type=template&id=438de9dc&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style1 from "./view.vue?vue&type=style&index=1&id=438de9dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438de9dc",
  null
  
)

export default component.exports